module.exports = __webpack_public_path__ + "img/auth-stage-vertical.08f6abab.png";